import { IntlContext, useTranslator } from '@jutro/locale';
import { useModal } from '@jutro/components';
import {
    useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
    withViewModelService
} from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import React, {
    useContext,
    useEffect,
    useState,
    useCallback
} from 'react';
import { AgencyAdminService } from '../../../../capabilities/twia-capability-agencyadmin';
import styles from './EditUser.module.scss'
import metadata from './EditUser.metadata.json5';
import messages from './EditUser.messages.js'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { CheckboxField } from '@jutro/legacy/components';

function EditUser(props) {
    const { onValidate, isComponentValid, registerComponentValidation } =
        useValidation('EditUser');
    const { refreshData } = useDataRefresh();
    const [userVM, setUserVM] = useState({});
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const [sumbitDisable, setSumbitDisable] = useState(true);
    const [userNameVisible, setUserNameVisible] = useState();
    const [statusVisible, setStatusVisible] = useState();
    const [checkBoxVisible, setCheckBoxVisible] = useState();
    const [editDetails, setEditDetails] = useState();
    const [userProfileButton, setUserProfileButton] = useState();
    const [associationName_TWIA, setassociationName_TWIA] = useState();
    const [licenseNumber, setlicenseNumber] = useState();
    const { showConfirm, showAlert } = useModal();
    const translator = useTranslator();
    // DE15318 Show error when component is invalid and Make email readonly
    const [showErrors, setShowErrors] = useState(false);
    let oldData;

    const {
        userData,
        onCancel,
        onSubmit,
        agencyList,
        userListVM,
        showEdit,
        history
    } = props;

    const ACTION_MSG = {
        confirmAction: {
            title: translator(messages.userProfileTitle),
            message: translator(messages.userProfileMessage),
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: translator(messages.confirmText),
        }
    };

    // DE15456
    const ACTION_MSG_ROLE = { 
        cancelAction: {
            title: translator(messages.RoleValidationTitle),
            message: translator(messages.RoleValidationMessage),
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: translator(messages.RoleButtonCloseMessage),
        }
    };

    const [userProfileVisible, setUserProfileVisibile] = useState(!(showEdit || showEdit !== undefined));

    useEffect(() => {
        if (showEdit) {
            setEditDetails(false);
            setUserNameVisible(true);
            setStatusVisible(true);
            setCheckBoxVisible(true);
            setUserVM(userListVM);
            setUserProfileButton(false)
        }
        else {
            setEditDetails(true);
            setUserNameVisible(false);
            setStatusVisible(false);
            setCheckBoxVisible(false);
            setUserProfileButton(false);
        }

        if (_.isUndefined(userListVM)) {

            AgencyAdminService.getCurrentUser(authHeader).then((res) => {

                if (res.associationName_TWIA === 'twia') {
                    setassociationName_TWIA('twia');
                    setlicenseNumber(res.tdiLicenseNumber_TWIA)

                    const user = viewModelService.create(
                        res,
                        'pc',
                        'org.twia.elevate.edge.capabilities.agent.dto.UserDTO'
                    )

                    setUserVM(user);
                }
            })
            // Done fixes for tfpa User Profile
            AgencyAdminService.loadUserOrgInfo_tfpa(authHeader).then((res) => {

                if (res.associationName_TWIA === 'tfpa') {
                    setassociationName_TWIA('tfpa');
                    setlicenseNumber(res.organization_EXT.tdilicenseNumber)

                    const user = viewModelService.create(
                        res,
                        'pc',
                        'org.twia.elevate.edge.capabilities.agent.dto.UserDTO'
                    )

                    setUserVM(user);
                }
            })

        }
    }, []);

    const cancel = useCallback(() => {
        if (showEdit) {
            onCancel();
        } else {
            history.go('/administration');
        }
        // onSubmit(userVM.value);
    },[history, showEdit]);

    const submit = useCallback(() => {
        
        // DE15456
        let roleSelected = false;

        if (!isComponentValid) {
            setShowErrors(true)

            return false
        }

        userVM.value.userRoles.map((role) => {
            if (role.isApplicable) {
                roleSelected = true;
            }
        });

        if(roleSelected){
            const currentStatus = _.get(userVM, 'status.value')
            currentStatus === "Active" ? _.set(userVM, 'status.value', true) : _.set(userVM, 'status.value', false)
            // DE18090
            if (userVM?.value?.associationName_TWIA === 'twia'|| props?.authUserData?.associationName_TWIA === 'twia') {
                // DE15437
                AgencyAdminService.editUser(userVM.value, authHeader).then((res) => {
                    history.go('/administration');
                })
            }
            else {
                AgencyAdminService.editUser_tfpa(userVM.value, authHeader).then((res) => {
                    history.go('/administration');
                })
            }
        } else {

            const message = ACTION_MSG_ROLE.cancelAction;

            showAlert(message).then(results => {

            })
        }
        // onSubmit(userVM.value);
    });

    const handleClick = useCallback(
        (value, path, index) => {
            setSumbitDisable(false);
            _.set(userVM.userRoles.value[index], 'isApplicable', value);
            setUserVM(userVM);
            refreshData();
        },
        [userVM, refreshData]
    );

    const getCheckBox = useCallback(
        (item, index) => {
            return (
                <CheckboxField
                    name={item.name}
                    id={item.name}
                    value={item.isApplicable}
                    // disabled={!item.isEditable_Ext}
                    onValueChange={e => handleClick(e, item, index)}
                />
            );
        },
        [handleClick]
    );

    const editUserDetails = useCallback(() => {
        oldData = _.clone(userVM.value);
        setUserNameVisible(false);
        setStatusVisible(false);
        setEditDetails(false);
        setUserProfileButton(true);
    }, [userVM])

    const cancelUserDetails = useCallback(() => {
        // DE15344 setting with old data when click on cancel
        _.set(userVM, 'firstName.value', oldData.firstName);
        _.set(userVM, 'lastName.value', oldData.lastName);
        _.set(userVM, 'phoneNumber.value', oldData.phoneNumber);
        setUserVM(userVM);
        setEditDetails(true);
        setUserProfileButton(false);
    }, [oldData, userVM])

    const submitUserDetails = useCallback(() => {
        if (!isComponentValid) {
            setShowErrors(true)

            return false
        }

        const message = ACTION_MSG.confirmAction;

        AgencyAdminService.updateUserProfileDetails(userVM.value, authHeader).then((res) => {
            showAlert(message).then(results => {
                if (results === 'confirm') {
                    setEditDetails(true);
                    setUserProfileButton(false);
                }
            })
        })

    })

    const writeValue = useCallback(
        (value, path) => {
            _.set(userVM, `${path}.value`, value);
            setUserVM(userVM);
            setSumbitDisable(false);
            refreshData();
        },
        [userVM, refreshData]
    );


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {

        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
            showErrors,
        },
        userRolesTable: {
            data: userVM?.userRoles ? statusVisible ? userVM?.userRoles.value : userVM?.userRoles.value.filter(role => role.isApplicable) : [] // DE15372
        },
        usersInformation: {
            content: userData?.displayName// translator(selectedUser.displayName)
        },
        status: {
            value: userVM?.status?.value, // DE18995
            visible: statusVisible
        },
        submitButton: {
            disabled: sumbitDisable// JSON.stringify(userData) === JSON.stringify(userVM?.value)
        },
        userName: {
            visible: userNameVisible
        },
        userProfileStatus: {
            value: userVM?.status?.value, // DE18995
            visible: !statusVisible
        },
        userProfileUserName: {
            visible: !userNameVisible
        },
        checkbox: {
            visible: checkBoxVisible
        },
        userDetailsTitle: {
            content: userVM?.value?.userAgencyName_EXT,
            visible: userProfileVisible
        },
        userDetailsTDI: {
            content: `TDI License Number:${licenseNumber}`,
            visible: userProfileVisible
        },
        userProfileTitle: {
            content: "User Profile",
            visible: userProfileVisible
        },
        firstName: {
            readOnly: editDetails
        },
        lastName: {
            readOnly: editDetails
        },
        emailAddress: {
            readOnly: true
        },
        emailInstruction: {
            visible: !editDetails
        },
        phoneNumber: {
            readOnly: editDetails
        },
        buttonGroup: {
            visible: showEdit || showEdit !== undefined ? true : false
        },
        buttonGroupUserProfile: {
            visible: userProfileButton
        },
        editUserDetailsButton: {
            visible: userProfileVisible
        },
        userProfileHeader: {
            visible: userProfileVisible
        },
        userHeader: {
            visible: userProfileVisible
        },
        userProfileHeader1: {
            visible: userProfileVisible
        },
        userProfileSpace: {
            visible: userProfileVisible
        },
        userProfileSpace1: {
            visible: userProfileVisible
        },
        userProfileSpace2: {
            visible: userProfileVisible
        },
        userInfoContainer: {
            className: showEdit ? "service-expressauto-grid" : "service-expressauto-grid-New"
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                userVM,
                id,
                path,
                overrideProps
            );
        },
        [userVM, overrideProps]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {

        },
        resolveCallbackMap: {
            clickCancel: cancel,
            clickSubmit: submit,
            getCheckBox: getCheckBox,
            editUserDetails: editUserDetails,
            cancelUserDetails: cancelUserDetails,
            submitUserDetails: submitUserDetails
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={userVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            onValueChange={writeValue}
            onValidationChange={onValidate}
        />
    );
}

EditUser.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

EditUser.defaultProps = {

};

export default withViewModelService(withAuthenticationContext(withRouter(EditUser)));
